var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "first-pay", class: { complete: _vm.isComplete } },
    [
      _c("div", { staticClass: "icon-complete" }),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          {
            staticClass: "btn",
            on: {
              click: function ($event) {
                return _vm.$bus.$emit("welfare-events", "toStore")
              },
            },
          },
          [
            _c("div", { staticClass: "icon" }),
            _c("div", { staticClass: "txt" }, [
              _vm._v(_vm._s(_vm.$t("text_recharge_now"))),
            ]),
          ]
        ),
        _c("div", { staticClass: "tips" }, [
          _c("div", [_vm._v("* " + _vm._s(_vm.$t("text_welfare_rule_1")))]),
          _c("div", [_vm._v("* " + _vm._s(_vm.$t("diamond_use_rule")))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }